import EventBus from '../../../shared/js/wirebox/event-bus'
import jQuery from 'jquery'

EventBus.subscribe('run-modules', () => {
    if (window.history.length > 1) {
        jQuery('html').addClass('has-history')
    }
})